<template>
    <section class="container">
        <section class="panel center-block">
            <div class="container-fluid">

                <!-- CACHER SI PAS TESTEUR-->
                <div class="text-center" v-show="$parent.IsTesteur()">
                    <router-link class="btn btn-warning" to="/ListeQuestions">&lsaquo;&lsaquo; Retour</router-link>
                </div>
                <!-- CACHER SI PAS TESTEUR-->
                <div class="countdown" :class="{isfixed: isfixed}">
                    <canvas id="pie-countdown" width="80" height="80" class=""></canvas>
                    <canvas id="pie-background" width="86" height="86"></canvas>
                    <span class="points">{{QUESTION.NombredePoints}}<br>points</span>
                    <span class="pulse1"></span>
                    <span class="pulse2"></span>
                </div>
                <h1 class="sep mt-3">Question of the day</h1>
                <p class="hauracherell">{{QUESTION.Intitule}}</p>
                <div class="group__img" v-show="QUESTION.Images && QUESTION.Images.length>0">
                    <a href="javascript:void(0)" v-on:click="ShowImage(QUESTION.Images[0])">
                        <img :src="$parent.GetPathImage(QUESTION.Images[0])" />
                    </a>
                </div><!-- GROUP IMG-->
                <div class="video__player mt-4" v-show="QUESTION.LienVideo">
                    <div>
                        <iframe width="560" height="315" :src="QUESTION.LienVideo" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                </div><!-- VIDEO PLAYER-->
                <div class="field mt-5">
                    <input type="text" v-model="SelectedOne" class="bg-light" placeholder="Votre réponse..." />

                    <a href="javascript:void(0)" v-show="ReponseImage!==null" v-on:click="ShowImage(ReponseImage)">
                        <img :src="$parent.GetPathImage(ReponseImage)" />
                    </a>
                </div>
                <button class="btn btn-primary w-100" v-on:click="SaveReponse"><i class="icon thumb-up-white"></i> Valider ma réponse</button>
            </div>
        </section><!-- PANEL -->
        <span class="panel-bottom"></span>
        <section class="modal" v-bind:class="{ modalopen: modalOpen_required }">
            <div class="modal-content bg-danger">
                <p class="text-center">
                    <i class="icon smiley-tongue"></i>
                </p>
                <p>Attention, pour relever le défi de la question du jour, vous devez quand même y répondre!</p>
                <div class="text-center">
                    <button class="btn btn-border-white" v-on:click="modalOpen_required = ! modalOpen_required">Fermer la fenêtre</button>
                </div>
            </div>
        </section><!-- MODAL-->
        <section class="modal" v-bind:class="{ modalopen: modalOpen_image }">
            <div class="modal-content bg-white">
                <button class="btn btn-icon btn-warning btn-close" v-on:click="modalOpen_image = ! modalOpen_image"><i class="icon icon-close"></i></button>
                <img :src="srcImage" />
            </div>
        </section><!-- MODAL-->
    </section><!-- CONTAINER FLUID-->
</template>
<script>
    import $ from 'jquery';
    import { Utility } from '../configs/configpaths';
    export default {
        data: function () {

            return {
                QUESTION: { Images: [] },
                ReponseImage:null,
                TITRE: "",
                modalOpen_required: false,
                modalOpen_image: false,
                SelectedOne: "",
                srcImage: "",
                isfixed: false
            };
        },

        mounted: function () {

            var _self = this;
            _self.$parent.GloablEvents();

            window.addEventListener('scroll', _self.scrolling);

            var CURRENT_USER = Utility.GetCurrent();
            var TOKEN = Utility.GetToken();
            if (!CURRENT_USER) {

                _self.$router.push('/');
            }
            var settings = {
                "crossDomain": true,
                "url": _self.BASE_URL + "api/question/Statut",
                "data": {
                    "id": parseInt(_self.$route.params.id),
                    "participant": parseInt(CURRENT_USER.Id),
                    "isTesteur": CURRENT_USER.Role === "TESTEUR"
                },
                "method": "GET",
                "headers": {
                    'Authorization': 'Bearer ' + TOKEN
                }
            };

            $.ajax(settings).done(function (response) {

                if (response === true) {
                    _self.$router.push('/DejaJoue/' + parseInt(_self.$route.params.id));
                } else {
                    _self.GetQuestion();
                }

            });
        },
        methods: {
            scrolling: function () {
                if (window.scrollY >= 223) {
                    this.isfixed = true;
                } else {
                    this.isfixed = false;
                }
            },
            ShowImage: function (img) {
                this.modalOpen_image = !this.modalOpen_image;
                this.srcImage = this.$parent.GetPathImage(img);

            },
            GetQuestion: function () {
                var _self = this;
                var CURRENT_USER = Utility.GetCurrent();
                var TOKEN = Utility.GetToken();
                if (!CURRENT_USER) {
                    _self.$router.push('/');
                }
                var settings = {
                    "crossDomain": true,
                    "url": _self.BASE_URL + "api/question/item",
                    "data": {
                        "id": parseInt(_self.$route.params.id),
                        "participant": parseInt(CURRENT_USER.Id),
                    },
                    "method": "GET",
                    "headers": {
                        'Authorization': 'Bearer ' + TOKEN
                    }
                };

                $.ajax(settings).done(function (response) {
                    _self.QUESTION = response;
                    _self.ReponseImage = response.Reponses[0].Image;
                    if (_self.QUESTION.LienVideo) {
                        if (_self.QUESTION.LienVideo.includes("vimeo") && !_self.QUESTION.LienVideo.includes("player.vimeo.com/video/")) {
                            _self.QUESTION.LienVideo = _self.QUESTION.LienVideo.replace("vimeo.com", "player.vimeo.com/video");
                        } else {
                            _self.QUESTION.LienVideo = _self.QUESTION.LienVideo.replace("watch?v=", "embed/");
                            _self.QUESTION.LienVideo = _self.QUESTION.LienVideo.replace("&feature=youtu.be", "");

                        }
                    }

                    if (_self.QUESTION.AutoPlay === true && _self.QUESTION.LienVideo) {
                        if (String(_self.QUESTION.LienVideo).indexOf("?") >= 0) {
                            _self.QUESTION.LienVideo += "&autoplay=1";
                        } else {
                            _self.QUESTION.LienVideo += "?autoplay=1";
                        }
                    }
                    _self.$parent.initCountDown(_self.QUESTION.DelaiReponse * 60, _self.QUESTION.NombredePoints);

                });
            },
            SaveReponse: function () {
                var _self = this;
                var CURRENT_USER = Utility.GetCurrent();
                var reponse = _self.SelectedOne;

                if (!_self.SelectedOne || isNaN(parseInt(_self.SelectedOne))) {
                    this.modalOpen_required = true;
                    return;
                }
                this.modalOpen_required = false;
                var isTesteur = CURRENT_USER.Role === "TESTEUR";
                var TOKEN = Utility.GetToken();

                if (!CURRENT_USER) {

                    _self.$router.push('/');
                }
                var settings = {
                    "async": false,
                    "crossDomain": true,
                    "url": _self.BASE_URL + "api/Question/Reponse",
                    "data": {
                        "questionId": parseInt(_self.$route.params.id),
                        "participant": parseInt(CURRENT_USER.Id),
                        "reponse": reponse,
                        "delai": _self.$parent.Delai,
                        "isTesteur": isTesteur

                    },
                    "method": "GET",
                    "headers": {
                        'Authorization': 'Bearer ' + TOKEN
                    }
                };

                $.ajax(settings).done(function () {
                    _self.$router.push('/Reponse/' + parseInt(_self.$route.params.id));
                });
            }
        }
    }
</script>
<style lang="scss" scoped>
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
